import { useQuery } from '@tanstack/react-query';

import { useAppSelector } from 'store';

import { $apiWithoutClient } from 'modules/global';

import { IFinishedTest } from '..';

export const useFinishedOlympic = () => {
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  const { data, ...args } = useQuery<{ finishedOlympic: IFinishedTest[] }>({
    queryKey: ['finished-olympic'],
    queryFn: async () => {
      const { data } = await $apiWithoutClient.get('/olympic/olympics-list-finish');

      return { finishedOlympic: data?.data };
    },
    enabled: isAuthenticated
  });

  return { ...data, ...args };
};
